import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import AyacuchoIcon from "../../assets/images/ayacucho/lg.png";
import Style from "../../styles/js/StyleUsers";
import DataUser from "./DataUser";
import Divider from "@material-ui/core/Divider";
import RolesAdmin from "./RolesAdmin";
import Alert from "../../components/common/SnackAlert.js";
import { generalErrors } from "../../consts/ErrorMessages.js";

export default function EditUsers({
  handleClose,
  inputsForm,
  roles,
  handlePrimaryRoleChange,
  handleSecondaryRolesChange,
  alertOpen,
  setAlertOpen,
}) {
  const style = Style();

  const handleLocalPrimaryRole = (e) => {
    handlePrimaryRoleChange(e, inputsForm);
  };
  const handleLocalSecondaryRoles = (newSecondaryRoles) => {
    handleSecondaryRolesChange(
      inputsForm.userId,
      inputsForm.additionalRoles,
      newSecondaryRoles
    );
  };
  return (
    <Dialog fullScreen open onClose={handleClose}>
      <form className={style.rootBusiness} autoComplete="off">
        <AppBar className={style.appBarForm}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={style.title}>
              Datos del Usuario
            </Typography>
            <img src={AyacuchoIcon} alt="Ayacucho" className={style.image} />
            <Button
              style={{ marginLeft: "auto", float: "right" }}
              onClick={handleClose}
              autoFocus
              color="inherit"
            >
              Cerrar
            </Button>
          </Toolbar>
        </AppBar>

        <DataUser
          name={inputsForm.name}
          lastName={inputsForm.lastName}
          photoUrl={inputsForm.photoUrl}
          gender={inputsForm.gender}
          phoneNumber={inputsForm.phoneNumber}
          email={inputsForm.email}
          birthDate={inputsForm.birthDate}
        />
        <Divider className={style.divider} />
        <RolesAdmin
          mainRole={inputsForm.role}
          roles={roles}
          currentRoles={inputsForm.additionalRoles}
          handleClose={handleClose}
          handlePrimaryRole={handleLocalPrimaryRole}
          handleSecondaryRoles={handleLocalSecondaryRoles}
        />
      </form>
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        mensaje={generalErrors.server}
        severity="error"
      ></Alert>
    </Dialog>
  );
}
